define('SuiteCommerce.OrderStatus.OrderFinder.OrderSummary.View', [
	'suitecommerce_orderstatus_summary.tpl',
	'Backbone',
	'Handlebars',
	'SuiteCommerce.OrderStatus.Utils',
	'underscore',
], function define(Template, Backbone, Handlebars, Utils, _) {
	'use strict';
	return Backbone.View.extend({
		template: Template,
		initialize: function initialize(options) {
			this.summaryData = options.summaryData;
			this.currency = options.currency;
		},
		getContext: function getContext() {
			return {
				viewElements: {
					panelTitle: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryLabel'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryLabel'),
					},
					subtotal: {
						label: Utils.getConfigurationParameter('orderDetailsSummarySubtotal'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummarySubtotal'),
					},
					discountTotal: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryDiscountTotal'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryDiscountTotal'),
					},
					shippingCost: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryShippingTotal'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryShippingTotal'),
					},
					taxtTotal: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryTaxTotal'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryTaxTotal'),
					},
					giftCertApplied: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryGiftCertificate'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryGiftCertificate'),
					},
					total: {
						label: Utils.getConfigurationParameter('orderDetailsSummaryTotal'),
						show: !!Utils.getConfigurationParameter('orderDetailsSummaryTotal'),
					},
				},
				summaryData: this.formatSummaryData(),
			};
		},
		formatSummaryData: function formatSummaryData() {
			var self = this;
			var summaryData = this.summaryData;
			_.each(_.keys(summaryData), function formatCurrency(key) {
				summaryData[key + '_formatted'] = Utils.formatCurrency(summaryData[key], self.currency.displaysymbol);
			});
			return summaryData;
		},
	});
});
